// Entrypoint compiled by Vite (see vite.config.ts / config/vite.json). Keep it a thin reference
// layer — the actual application logic lives under app/javascript/frontend.

// Must come first: publishes window.$ / window.jQuery before any jQuery plugin is evaluated.
import '../frontend/jquery-setup.js'
// Publishes window.moment / window.momentTimezone (read by the Playwright suite).
import '../frontend/moment-setup.js'

import $ from 'jquery'

import 'bootstrap'
import 'js-cookie'
import 'bootstrap/js/dist/tooltip'

// UMD bundle. Its first wrapper self-registers `$.fn.datetimepicker` through the CJS branch, but
// the second one (the vendored jquery-mousewheel plugin the time column scrolls with) only
// *returns* its factory there — webpack took the AMD branch and got both. Calling the export
// restores the wheel handler.
import datetimepickerMousewheel from 'jquery-datetimepicker'

import 'bootstrap-table'
import 'bootstrap-table/dist/locale/bootstrap-table-ja-JP.js'

// Quill's two themes, from the package that already provides its JS (`frontend/rich-editor.js`),
// instead of the two cdn.quilljs.com 1.3.6 links this entry replaced: `bubble` for the fields whose
// toolbar is a selection popover, `snow` for the release body's persistent toolbar row. They share
// their base rules and scope everything else under `.ql-bubble` / `.ql-snow`, so they coexist —
// order kept as the <head> had it. The extracted `frontend.css` is linked ahead of the customer
// stylesheet entry (`packs/theme.scss`) in layouts/_head.html.erb, because the design-system
// repaint in mack/sass/components/common/_editor.scss overrides these rules on plain source
// order.
import 'quill/dist/quill.bubble.css'
import 'quill/dist/quill.snow.css'

import '../frontend/app.js'
import '../frontend/media-list.js'
// Self-initializing on DOMContentLoaded: auto-dismisses the layout flash.
import '../frontend/toast.js'

if (typeof datetimepickerMousewheel === 'function' && !$.fn.mousewheel) {
  datetimepickerMousewheel($)
}
